<template>
  <div class="preview-modal">
    <div class="preview" :class="[ {horizontal: productType == 'soundwave'}, frameColor ]">
      <button v-on:click="close" class="close"><img src="../assets/img/ic_close_b.svg" alt="Close" /></button>
      <img v-bind:src=imageUrl>
      <div class="inner-border"></div>
    </div>
    <div class="backdrop" v-on:click="close"></div>
  </div>
</template>
<script>
  export default {
    name: "PreviewModal",
    props: {
      imageUrl: String,
      frameColor: String,
      productType: String
    },

    methods: {
      close() {
        this.$emit('close');
      },
    },
  };
</script>
<style scoped>
  @import url('../assets/css/modal.css');

  .preview-modal {
    position: fixed;
    z-index: 100;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .preview {
    position: relative;
    z-index: 100;
    display: flex;
    flex-direction: column;
  }

  .inner-border {
    pointer-events: none;
    position: absolute;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    border: 0px solid rgba(0, 0, 0, 0);
    box-shadow: inset 0px 0px 0px 1px #e5e5e5;
  }

  .preview.BLACK {
    border: 20px solid #000;
  }

  .preview.WHITE {
    border: 20px solid #ffffff;
  }

  .preview.WOOD {
    border: 20px solid #E3C297;
  }

  .preview.horizontal.BLACK {
    border: 26px solid #000;
  }

  .preview.horizontal.WHITE {
    border: 26px solid #ffffff;
  }

  .preview.horizontal.WOOD {
    border: 26px solid #E3C297;
  }

  .preview img {
    pointer-events: none;
    max-height: 90vh;
    max-width: 90vw;
  }

  @media screen and (max-width: 768px) {
    .preview-modal {
      display: none;
    }
  }
</style>